import { BLUE } from 'ui/constants'

export const antdTheme = {
  token: {
    fontFamily: 'Inter',

    stickyScrollBarBg: BLUE,
    stickyScrollBarBorderRadius: 0
  },
  components: {
    Table: {
      stickyScrollBarBg: BLUE,
      stickyScrollBarBorderRadius: 0
    },
    Modal: {
      footerGap: 8
    }
  }
}
